import React, { useState, useEffect } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import DiscoveryTooltip from 'DiscoveryTooltip';

const ExcludeIfGroup = (props) => {
  const sample = props.sample;
  const location = props.location;
  const [active, setActive] = useState(props.active);
  const [value, setValue] = useState(props.value);

  // useEffect(() => {
  //   if (props.creatingNewRules === true) {
  //     setActive(false);
  //     setValue("");
  //   } else if (props.active === true) {
  //     setActive(props.active);
  //     setValue(props.value);
  //   }
  // }, [props.creatingNewRules]);
  
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    setActive(props.active);
  }, [props.active]);

  return (
    <InputGroup size='sm' className="mb-3">
      <InputGroup.Prepend>
        <InputGroup.Checkbox 
          disabled
          checked={active}
          onChange={(evt) => {
            setActive(evt.target.checked);
            let newValue = {
              active: evt.target.checked
            };
            newValue[location] = value;
            props.update(newValue);
          }
        }/>
        <InputGroup.Text>Exclude </InputGroup.Text>
      </InputGroup.Prepend>
      <FormControl
        readOnly
        value={sample} 
      />
      <InputGroup.Append>
        <InputGroup.Text> if </InputGroup.Text>
      </InputGroup.Append>
      <FormControl
        readOnly
        value={location} 
      />
      <InputGroup.Append>
        <InputGroup.Text> is like </InputGroup.Text>
      </InputGroup.Append>
      <DiscoveryTooltip text='Exclude fields feature coming soon'>
        <FormControl
          value={value}
          disabled
          onChange={(evt) => {
            setValue(evt.target.value.split(','));
            let newValue = {
              active: active
            };
            newValue[location] = evt.target.value.split(',');
            props.update(newValue);
          }
        }/>
      </DiscoveryTooltip>
    </InputGroup>
  );
}

export default ExcludeIfGroup;